// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".navbar-spacing[data-v-4a8639b8] {\n  margin-top: 72px;\n}\n.box-icon[data-v-4a8639b8] {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  text-align: center;\n  height: 100px;\n}\n.box-icon__active[data-v-4a8639b8] {\n  background: grey;\n}\n.box-icon[data-v-4a8639b8]:hover {\n  background: grey;\n}\n.addition-button[data-v-4a8639b8] {\n  min-height: 80px;\n}\n.addition-button[data-v-4a8639b8]:hover {\n  background: rgba(255, 255, 255, 0.4);\n}", ""]);
// Exports
module.exports = exports;
